import { Configuration, FrontendApi } from "@ory/client-fetch";

// Returns null when no Kratos origin is configured, which disables Ory auth.
export default function createOryClient(basePath: string | undefined) {
  return basePath
    ? new FrontendApi(new Configuration({ basePath, credentials: "include" }))
    : null;
}
